import { IconButton, Input, Tooltip, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomCard from "../../components/CustomCard";
import AuthLayout from "../layouts/AuthLayout";
import EventCard from "./components/EventCard";
import SearchIcon from "@mui/icons-material/Search";
import { updateState } from "../../redux/commonSlice";
import {generateLighterContrastColor,  timeStampToString } from "../../utils/commonServices";
import { useNavigate } from "react-router-dom";
import EventCreationDrawer from "../eventcreation";
import CustomUserCard from "../events/components/CustomUserCard";
import "@fontsource/rubik";
import CustomSortOptions from "../events/components/CustomSortOptions";
import filmingTutorialImage from "../../assets/filmingTutorialCard.png"
import { eventSortOptions, eventStageOptions, sortByOptions } from "../../constants/staticData";
import useEventSort from "./hooks/useEventSort";
import useEventTypeList from "../eventcreation/hooks/useEventTypeList";
import PopupVideoPlayer from "../../components/PopupVideoPlayer";
import DeleteConfirmationPopup from "./components/DeleteConfirmationPopup";
import useDeleteProject from "./hooks/useDeleteProject";
import DeleteDeclinePopup from "./components/DeleteDeclinePopup";
import { updateReviewState } from "../../redux/reviewSlice";
import { updateCreationState } from "../../redux/eventCreationSlice";
import DeclineEditProjectPopup from "./components/DeclineEditProjectPopup";
import { setAllMediaFilesArray } from "../../redux/mediaFilesSlice";
import { setAssetState } from "../../redux/assetSlice";
import BrandingWatermarkOutlinedIcon from '@mui/icons-material/BrandingWatermarkOutlined';
import { gaEvents } from "../../ga/actions";
import MainLogoCard from "./components/MainLogoCard";
import AllTeamsCard from "./components/AllTeamsCard";
import TeamCreationDrawer from "../teams";
import DeleteTeamPopup from "../teams/components/DeleteTeamPopup";
import RenameTeamPopup from "../teams/components/RenameTeamPopup";
import butterfly from './../../assets/butterfly_navigation.png'
import { getRoleNamesFromIds, getRoles, getUserRoles } from "../../commonactions/actions";
import { checkTokenSession, getAllEvents, getAllTeams, viewOrganisationMember } from "./actions";
import InviteOrganisationMembersPopup from "./components/InviteOrganisationMembersPopup";
import RemoveOrganisationMemberConfirmationPopup from "./components/RemoveOrganisationMemberConfirmationPopup";
import AssignAdminRolePopup from "./components/AssignAdminRolePopup";
import { viewProjectMembers } from "../events/actions";
import { updatePermissionState } from "../../redux/permissionSlice";
import ViewOrganisationMembersPopup from "./components/ViewOrganisationMembersPopup";
import BackdropCreateProject from "../eventcreation/components/BackdropCreateProject";
import { PERMISSION } from "../../constants/constants";
import usePermissions from "../../hooks/usePermissions";
import { updateTeamState } from "../../redux/teamSlice";
import { setSnackbar } from "../../redux/messageSlice";
import EventTypeFilter from "./components/EventTypeFilter";
import useProjectTypeFilter from "./hooks/useProjectTypeFilter";
import useVideoLengthList from "../eventcreation/hooks/useVideoLengthList";
import { getContrastRatio } from '@mui/material/styles';
// import { customTheme as theme } from "../../theme/customTheme";
import useCustomTheme from "../../theme/useCustomTheme";
import {  goToCopilot } from "../../utils/commonServices";
import CustomButton from "../../components/CustomButton";
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import EventStageFilter from "./components/EventStageFilter";
import useProjectStageFilter from "./hooks/useProjectStageFilter";
import ProductTour from "../../components/producttour/ProductTour";
import { CREATE_PROJECT_UNAVAILABLE_MESSAGE, CREDITS_EXHAUSTED_MESSAGE, isCreateProjectUnavailableEffective } from "../../utils/availability";


let counter = 0;

const Dashboard = (props) => {
    const createEventReducer = useSelector((state) => state.createEventReducer);
    const commonReducer = useSelector((state) => state.root.commonReducer);
    const dropdownReducer = useSelector((state) => state.root.dropdownReducer);
    const teamsReducer = useSelector((state) => state.root.teamsReducer);
    const permissionsReducer = useSelector((state) => state.permissionsReducer)
    const [selectedSortbyValue, setSelectedSortbyValue] = useState('view_all');
    const [searchedArray, setSearchedArray] = useState(commonReducer.events);
    const [searchString, setSearchString] = useState("");
    const [deleteProject, deleteEventStatus] = useDeleteProject(commonReducer.production_event_id);
    const [selectedProjectStage, setSelectedProjectStage] = useState(['View All']);
    const [selectedProjectTypeValue, setSelectedProjectTypeValue] = useState(['View All']);
     const [projectStageEvents] = useProjectStageFilter(searchedArray, selectedProjectStage);
    const [projectTypeEvents] = useProjectTypeFilter(projectStageEvents, selectedProjectTypeValue);
    const [sortedEvents] = useEventSort(projectTypeEvents, selectedSortbyValue);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [eventType, selectedEventType] = useEventTypeList()
   // const {eventCountByStatus, statusCheckHandler} = useFilter("status_type")
    const [members, setMembers] = useState(teamsReducer.organization_members)
    const [hasPermission] = usePermissions();
    const [videoLength, selectedVideoLength] = useVideoLengthList()
    const [theme] = useCustomTheme()
    const [showCustomerDashboardNudge, setShowCustomerDashboardNudge] = useState(false)

    const hasAnalyticsAccess = commonReducer?.analytics_access || window.localStorage.getItem('analytics_access') === 'true'
    useEffect(() => {
        if (hasAnalyticsAccess && window.localStorage.getItem('cd_nav_nudge_seen') !== 'true') {
            setShowCustomerDashboardNudge(true)
        }
    }, [hasAnalyticsAccess])


    useEffect(()=>{
        dispatch(updateTeamState({selected_team: null}))
        getUserRoles(dispatch, navigate, permissionsReducer)
        getAllEvents(dispatch, navigate, {commonReducer});
        if(dropdownReducer.organisation_roles?.length === 0 || dropdownReducer.team_roles?.length === 0 || dropdownReducer.project_roles?.length === 0 ){
            getRoles(dispatch, navigate)
        }
        // if(permissionsReducer?.permissions_list?.length === 0){
        //     getPermissions( dispatch)
        // }
      
        getAllTeams(dispatch, navigate)
        dispatch(updatePermissionState({org_role_id: teamsReducer?.organization_members?.find(mem => mem.id === commonReducer?.user_id)?.role?.id}))
    },[])
    useEffect(()=> {
        hasPermission(PERMISSION.ORGANISATION.MEMBER.VIEW) && viewOrganisationMember(dispatch, navigate, commonReducer)
    },[permissionsReducer.permissions_master[PERMISSION.ORGANISATION.MEMBER.VIEW]])

    ////////////////////////////////////////permission ends//////////////////////////////////////

    //***********Rerenders the dashboard as soon as all the events are successfully fetched************ */
    useEffect(()=> {
        if (searchString) {
            const temp = commonReducer.combined_filter?.filter((searchedEvent) => {
                if (searchedEvent?.name?.toLowerCase()?.includes(searchString.toLocaleLowerCase())) return searchedEvent;
                if (searchedEvent?.event_type?.name?.toLowerCase()?.includes(searchString.toLocaleLowerCase())) return searchedEvent;
                if (timeStampToString(searchedEvent?.start_date)?.toLowerCase()?.includes(searchString.toLocaleLowerCase())) return searchedEvent;
                if (timeStampToString(searchedEvent?.end_date)?.toLowerCase()?.includes(searchString.toLocaleLowerCase())) return searchedEvent;
            });
            setSearchedArray(temp);
        } else {
            setSearchedArray(commonReducer.combined_filter);
        }
    }, [commonReducer.combined_filter])

  

    useEffect(()=> {
        setMembers(teamsReducer?.organization_members)
        dispatch(updatePermissionState({org_role_id: teamsReducer?.organization_members?.find(mem => mem.id === commonReducer?.user_id)?.role?.id}))
    }, [teamsReducer?.organization_members])

   const disableDelete = (e)=> {
    const fileList = props.uploadProps.selectedFiles
    return !!fileList?.find(item => item.extraPayload.event_id == e.id)
   }
//    console.log("upload List", sortedEvents)
    const onSearch = (event) => {
        setSearchString(event.target.value);
        if (commonReducer.combined_filter?.length > 0) {
            const temp = commonReducer.combined_filter?.filter((searchedEvent) => {
                if (event.target.value == "") {
                    return searchedEvent;
                } else if (
                    searchedEvent?.name
                        ?.toLowerCase()
                        ?.includes(event.target.value.toLocaleLowerCase())
                ) {
                    return searchedEvent;
                } else if (
                    searchedEvent?.event_type?.name
                        ?.toLowerCase()
                        ?.includes(event.target.value.toLocaleLowerCase())
                ) {
                    return searchedEvent;
                } else if (
                    timeStampToString(searchedEvent?.start_date)
                        ?.toLowerCase()
                        ?.includes(event.target.value.toLocaleLowerCase())
                ) {
                    return searchedEvent;
                } else if (
                    timeStampToString(searchedEvent?.end_date)
                        ?.toLowerCase()
                        ?.includes(event.target.value.toLocaleLowerCase())
                )
                    return searchedEvent;
            });
            setSearchedArray(temp);
        }
        // setFilteredArray(filterArray(event));
    }

    //***********************LOGIC FOR CLICKS ON EVENT CARDS******************************************** */
    const onEventClick = (event) => {
        dispatch(setSnackbar({flag: false, type: 'error', message: "ACCESS DENIED!"}))
        dispatch(updateState({ production_event_id: event.id}));
        const tempEvent =  commonReducer.events?.find((e) => e.id == event.id)
       hasPermission(PERMISSION.PROJECT.MEMBER.VIEW) && viewProjectMembers({event_id: event?.id}, dispatch, navigate, {commonReducer})
        if(tempEvent?.status_type_order <= 3) {
            navigate(`/productionevent/${event.id}`);
        } else {
            navigate(`/completedevent/${event.id}`)
        }
    }; 

    useEffect(()=> {
        checkTokenSession(dispatch)
        dispatch(updateState({ production_event_id: null, open_agreement_popup: false}))
        dispatch(setAllMediaFilesArray({open_previous_project_media_popup:false, import_files_confirmation_popup:false}))
        dispatch(updateCreationState({extend_edit_date_popup: false}))
        dispatch(updateReviewState({open_request_changes_popup: false, open_video_accept_popup: false,}))
      //  dispatch(updateState({under_revision: false, new_video: false}))
    },[])
    // const goToCopilot = ()=> {
    //     const encryptedToken = encryptString(window.localStorage.getItem('token'));
    //     const encodedURIString = encodeURIComponent(encryptedToken);
    //     //window.location.href=`${process.env.REACT_APP_COPILOT_URL}/redirect/${encodedURIString}`;
    //     window.open(`${process.env.REACT_APP_COPILOT_URL}/redirect?k=${encodedURIString}`, '_blank')
    // }

    return <AuthLayout uploadProps = {props.uploadProps} sx={{ padding: '2% 3.2% 2.1% 2.2%' }}>
        <Box gap={2} className='flex row a-center j-end' sx={{ pr: {xs:1, sm:3} }} >
           {commonReducer?.copilot_access && <img onClick={goToCopilot} src={butterfly} style={{ borderRadius: '5px', width: '230px', cursor: 'pointer'}} />}
            <Box id="main-dashboard-nav-trigger" sx={{ display: 'inline-flex' }}>
                <CustomUserCard />
            </Box>
        </Box>

        <ProductTour
            open={showCustomerDashboardNudge}
            onClose={() => setShowCustomerDashboardNudge(false)}
            storageKey="cd_nav_nudge_seen"
            steps={[{
                selector: '#main-dashboard-nav-trigger',
                placement: 'bottom',
                title: 'Your Account Dashboard is ready',
                content: "Click your account menu here and select \"Account Dashboard\" to see your usage, project status, and contract details in one place.",
            }]}
        />
        <Box className='flex row justify-center align-center' >

            <Box id="left" className='flex col' sx={{ maxWidth: { xs: '160px', sm:'28%',md: '23%', lg: '21%', xl: '22%' }, }} >
                {/* <CustomCard
                    
                    margin='0px 0px 20px 0px'
                    padding='17% 27% 11.3% 21.3%'
                    // height={{ xs: '200px', sm: '230px', md: '24vh', lg: '26vh', xl: '28vh' }}
                    sx={{ flex: 3 }}
                // width= {{xs:'200px', sm: '230px', md: '260px', lg: '320px', xl: '18.8vw' }} 
                >
                    <Box height='100%' className='flex col j-start a-center' >

                    <Box textAlign='center' sx={{ height: { xs: 20,sm:22, md: 26, lg: 30, xl: 42 },  }} >
                            <img src={luciLogo} height='100%' />
                        </Box>
                        <Box textAlign='center' sx={{mt: {xs: 2, md: 3, lg: 3, xl: 8}}}>

                        <Typography sx={{fontFamily: 'Rubik', fontWeight: 300, fontSize: {xs:'16px',md:'18px',lg:'23px',xl:'32px'}}} > Hello</Typography>
                        <Typography sx={{fontFamily: 'Rubik', color: '#000000', fontWeight: 300, fontSize: {xs:'10px',md:'12px',lg:'13.5px',xl:'20px'}, textTransform:'capitalize'}} >{commonReducer.user_name}</Typography>
                        </Box>
                    </Box>
                </CustomCard> */}
                <MainLogoCard/>
                <CustomCard
                    //  height={{ xs: '200px', sm: '230px', md: '26vh', lg: '30vh', xl: '32vh' }}
                    // width= {{ sm: '220px', md: '250px', lg: '300px', xl: '18vw' }} 
                    // sx={{ padding: '4vh 3vw', flex: 4 }}
                    
                >
                   {/* <Typography sx={{ fontSize: { xs: 8,sm:9, md: 10, lg: 11, xl: '16px' }, fontFamily: 'Rubik', fontWeight: 300, color: '#000000' , marginBottom:{xs:'10px',sm:'12px',md:'10px',lg:'10px',xl:'20px'}}}>Status Type</Typography> */}
                    {/* <FormGroup>
                        {
                            dropdownReducer.status_type != null && dropdownReducer?.status_type?.map((type, index) => {
                                return <FormControlLabel
                                    control={<Checkbox sx={{ '& .MuiSvgIcon-root': { fontSize: { xs: 10, md: 12, lg: 14, xl: 20 } } }} onChange={() => statusCheckHandler(index)} checked={type.checked} />}
                                    label={<Typography
                                        sx={{ fontFamily: 'Rubik', fontSize: { xs: 10, md: 12, lg: 14, xl: 20 }, fontWeight: 600 }}>
                                        {`${type.value} (${eventCountByStatus(type.order)})`}
                                    </Typography>}
                                />
                            })
                        }
                    </FormGroup> */}
                    {/* <EventFilter eventCounter = {eventCountByStatus} checkStatus = {statusCheckHandler} listType = 'status_type' counts/> */}
                    <AllTeamsCard />
                </CustomCard>
                <CustomCard
                    margin='20px 0px 0px 0px'
                    // height={{ xs: '15vh', sm: '230px', md: '18vh', lg: '18vh', xl: '18vh' }}
                    //  width= {{xs:'200px', sm: '230px', md: '260px', lg: '320px', xl: '18.8vw' }} 
                    sx={{ flex: 2, cursor: 'pointer' }}
                    onClick={()=> dispatch(updateState({play_tutorial: true}))}
                >
                 {/* <Box className="rubik" textAlign='center' m={0} p={0} sx={{height:'100%', }}> */}
                     <img src={filmingTutorialImage} height='100%' style={{objectFit:'cover', borderRadius:'5px'}} width='100%'/>
                 {/* </Box> */}
                </CustomCard>
            </Box>
            <Box id="right" width='100%' minWidth= '300px' ml={4.5}>
                <Box width='100%' className= 'flex row j-between' sx={{ marginTop: {xs: '40px', md: '48px', lg:'56px', xl:'64px'}, marginBottom: {xs: '12px', md: '15px', lg:'20px', xl:'30px'}}}>

                <Box id="search" 
                    sx={{flex: 1}}
                    //sx={{ marginBottom: { xs: '12px', md: '15px', lg: '18px', xl: '30px' } }} 
                >
                    <Input
                        // className={classes.text}
                        // inputProps={{ style: {fullWidth: true,
                        //       //color: '#F5F1E9',
                        //       fontSize: 20,
                        //       fontWeight: 400,
                        
                        //     //  borderColor: '#F5F1E9 !important'
                        // }
                        //     }}
                        value={searchString}
                        onChange={onSearch}
                        sx={{
                          //  minWidth: '160px',
                            borderBottom: 2,
                            borderColor: "#333333",
                            input: {
                                fontSize: { xs: '12px', md: '13px', lg: '15px', xl: '22px' },
                                fontWeight: 400,
                                color: "#000000",
                            },
                        }}
                        placeholder="Search"
                        // borderWidth={2}
                        // style={{color:'#F5F1E9', width: "90%", border: 2, borderBottomColor: '#F5F1E9'}} sx={{borderBottomColor:'#F5F1E9'}}
                        startAdornment={
                            <IconButton sx={{paddingBottom:1, fontSize: {xs:'12px',md:'14px',lg:'17px',xl:'24px'}, '& .MuiSvgIcon-root':{fontSize:{xs:'12px',md:'14px',lg:'17px',xl:'24px'}}, paddingRight:2}} >
                                <SearchIcon style={{ color: "#000000" }} />
                            </IconButton>
                        }
                        />
                </Box>
                {/* <Box sx={{display:'flex', justifyContent:'end', alignItems:'center', 
                            //marginBottom:{xs:'10px',sm:'14px',md:'16px',lg:'18px',xl:'25px'}, 
                           // marginTop:{xs:'5px',sm:'5px',md:'5px',lg:'10px',xl:'20px'}, 
                            cursor:'pointer'}} gap={{xs:0.3,sm:0.5, md:0.7, lg:1, xl:1.2}} pr={1}>

                    <CustomPopoverFilter listType= 'event_type_filter'  />
                </Box> */}
                <Box sx={{display:'flex', justifyContent:'end', alignItems:'center', 
                            //marginBottom:{xs:'10px',sm:'14px',md:'16px',lg:'18px',xl:'25px'}, 
                           // marginTop:{xs:'5px',sm:'5px',md:'5px',lg:'10px',xl:'20px'}, 
                            cursor:'pointer'}} gap={{xs:0.5,sm:0.7, md:0.9, lg:1.2, xl:1.4}} pr={1}>
                        <EventStageFilter
                         sortByOptions={eventStageOptions}
                         selectedProjectStage={selectedProjectStage}
                         setSelectedProjectStage={setSelectedProjectStage}
                          menuTitle = "Status"
                        />
                            
                        <EventTypeFilter
                         sortByOptions={eventSortOptions}
                         selectedProjectTypeValue={selectedProjectTypeValue}
                         setSelectedProjectTypeValue={setSelectedProjectTypeValue}
                        />
                       <CustomSortOptions
                         sortByOptions={eventSortOptions}
                         selectedSortbyValue={selectedSortbyValue}
                         setSelectedSortbyValue={setSelectedSortbyValue}
                         menuTitle = "Sort By"
                         // onChange={(newValue) => console.log(newValue)}
                        />

                       {commonReducer?.is_org_admin && <Box>
                            <CustomButton
                            btnText='Brand Box'
                            fullWidth={false}
                            onClick={() => {
                                if (commonReducer?.is_company_name_available === false) {
                                    dispatch(setAssetState({ brand_name_popup: true, brand_box_clicked: true }))
                                } else {
                                    navigate('/brandbox')
                                }
                            }}
                            type='button'
                            color='secondary'
                            variant='contained'
                            startIcon={<BrandingWatermarkOutlinedIcon sx={{fontSize:{xs:'12px !important',sm:'13px !important',md:'14px !important',lg:'15px !important',xl:'20px !important'}}} />}
                            style={{
                                borderRadius: '5px',
                                border: "none",
                                textTransform: 'none',
                                }}
                            sx={{fontSize:{xs:'8px',sm:'9px',md:'10px',lg:'11px',xl:'16px'}, fontWeight:600, height:{xs:'18px',sm:'18px',md:'20px',lg:'22px',xl:"36px"}, width:{xs:'100px',sm:'100px',md:'110px',lg:'120px',xl:'190px'}, fontFamily:'Rubik', mr: {sm: '8px', md: '10px', lg: '12px', xl: 1.5}}}
                            />
                        </Box>}

                           {/* {hasPermission(PERMISSION.ORGANISATION.PROJECT.CREATE) && <Box onClick={() =>{
                            checkTokenSession(dispatch, ()=>{
                                dispatch(updateCreationState({open_backdrop_project_creation: true}));
                                gaEvents.eventFormOpened()
                            })
                        }} 
                        sx={{ cursor: 'pointer', mr: {sm: '12px', md: '16px', lg: '20px', xl: 3} }} >

                     
                        <AddIcon color={theme.palette.primary.main === ('#00d744' || '#00D744') ? '#00d744' :  getContrastRatio('#08231B', theme.palette.primary.main) > 4.5 ? `${theme.palette.primary.main}` : generateLighterContrastColor(theme.palette.primary.main)} 
                        sx={{ 
                            // fontSize: { xs: '40px !important', sm: '44px !important', md: '50px !important', lg: '56px !important', xl: '82px !important' },
                            fontSize: { xs: '40px !important', sm: '40px !important', md: '45px !important', lg: '48px !important', xl: '70px !important' },
                             }} />

                        </Box>} */}

                       {hasPermission(PERMISSION.ORGANISATION.PROJECT.CREATE) && <Box>
                            <Tooltip title={isCreateProjectUnavailableEffective(commonReducer?.videos_pending, commonReducer?.credits_pending, commonReducer?.credit_based) ? (commonReducer?.credit_based ? CREDITS_EXHAUSTED_MESSAGE : CREATE_PROJECT_UNAVAILABLE_MESSAGE) : ''} arrow placement="top">
                            <span>
                            <CustomButton
                            btnText={ 'New Project'}
                            disabled={isCreateProjectUnavailableEffective(commonReducer?.videos_pending, commonReducer?.credits_pending, commonReducer?.credit_based)}
                            onClick={() =>{
                            checkTokenSession(dispatch, ()=>{
                                dispatch(updateCreationState({open_backdrop_project_creation: true}));
                                gaEvents.eventFormOpened()
                            })
                            }}
                            type='button'
                            color='button'
                            variant='contained'
                            endIcon={<AddRoundedIcon />}
                            style={{
                                borderRadius: '5px',
                                border: "none",
                                textTransform:'none',
                                // backgroundColor:theme.palette.secondary.main
                                }}
                            sx={{fontSize:{xs:'8px',sm:'9px',md:'10px',lg:'11px',xl:'16px'}, fontWeight:600, height:{xs:'18px',sm:'18px',md:'20px',lg:'22px',xl:"36px"}, width:{xs:'120px',sm:'120px',md:'120px',lg:'133px',xl:'225px'}, fontFamily:'Rubik',  mr: {sm: '12px', md: '16px', lg: '20px', xl: 3},  color:  theme.palette.primary.main === ('#00d744' || '#00D744') ? '#00d744' :  getContrastRatio('#08231B', theme.palette.primary.main) > 4.5 ? `${theme.palette.primary.main}` : generateLighterContrastColor(theme.palette.primary.main)}}
                            />
                            </span>
                            </Tooltip>
                        </Box>}

                   </Box>
                </Box>
                {/* <Box id="events" className='flex row f-wrap j-start a-start' sx={{ height: { xs: '78vh', sm: '66vh', md: '62vh', lg: '54vh', xl: '68vh' }, overflowY: "scroll", whiteSpace: 'nowrap', alignContent: 'flex-start' }} > */}
                <Box id="events" className='flex row f-wrap f-start a-start' sx={{ height: { xs: '71vh', sm: '67vh', md: '64vh', lg: '61vh', xl: '66vh' }, overflowY: "scroll", whiteSpace: 'nowrap', alignContent: 'flex-start', backgroundColor:'transparent',scrollbarWidth: 'none', msOverflowStyle: 'none', '&::-webkit-scrollbar': {display : 'none'}, }} >
                    {
                        sortedEvents?.length > 0 ? sortedEvents?.map((e) => {
                            const isDeleteDisabled = disableDelete(e);
                            return <EventCard onClick={() => onEventClick(e)} disableDelete = {isDeleteDisabled} event={e} sx={{ mt: 2, mr: 2, cursor: 'pointer' }} />
                        }) :
                        <Box className= 'flex col j-center a-center' sx={{overflowY: "initial", whiteSpace: 'normal'}} height='100%' width='100%'>

                             { hasPermission(PERMISSION.ORGANISATION.PROJECT.CREATE) ?  <Typography sx={{fontSize: 30, color: '#878887', fontWeight: 300, textAlign: 'center', mt:3}} >You have no existing Lucihub Project. <br/>
                                <Box  gap={1.5} className='flex a-center j-center' >Click Add button below to get started.
                                {/* <AddIcon color={theme.palette.primary.main === ('#00d744' || '#00D744') ? '#00d744' :  getContrastRatio('#08231B', theme.palette.primary.main) > 4.5 ? `${theme.palette.primary.main}` : generateLighterContrastColor(theme.palette.primary.main)} sx={{ fontSize: { xs: '20px', sm: '24px', md: '30px', lg: '36px', xl: '62px' }, }} />  */}
                                 </Box>
                             </Typography>:
                             <Typography sx={{fontSize: 30, color: '#878887', fontWeight: 300, textAlign: 'center', mt:3}} >You have no existing Lucihub Project. <br/> 
                             </Typography>}
                        </Box>
                    }
                 
                   
                </Box>
                {/* <Box className='flex row j-end a-end' width='100%' sx={{ mt: 2 , backgroundColor:'red'}} >
                       {hasPermission(PERMISSION.ORGANISATION.PROJECT.CREATE) && <Box onClick={() =>{ 
                            checkTokenSession(dispatch, ()=>{
                                dispatch(updateCreationState({open_backdrop_project_creation: true}));
                                gaEvents.eventFormOpened()
                            })
                        }} 
                        sx={{ cursor: 'pointer', mr: {sm: '12px', md: '16px', lg: '20px', xl: 3}, backgroundColor:'yellow' }} >

                     
                        <AddIcon color={theme.palette.primary.main === ('#00d744' || '#00D744') ? '#00d744' :  getContrastRatio('#08231B', theme.palette.primary.main) > 4.5 ? `${theme.palette.primary.main}` : generateLighterContrastColor(theme.palette.primary.main)} sx={{ fontSize: { xs: '40px !important', sm: '44px !important', md: '50px !important', lg: '56px !important', xl: '82px !important' }, }} />

                        </Box>}
                    </Box> */}
              {/* <Box>{{a:""}}</Box> */}

            </Box>
            <Box>

            </Box>
        </Box>
        {
            createEventReducer.open_form == true && <EventCreationDrawer/>
        }
       {
            commonReducer.play_tutorial == true && <PopupVideoPlayer tutorial />
       }
        {
            commonReducer.event_delete_popup == true && <DeleteConfirmationPopup deleteProject = {deleteProject} status = {deleteEventStatus}/>
            
        }
         {
            commonReducer.delete_decline_popup == true && <DeleteDeclinePopup/>
            
        }
        {createEventReducer.edit_decline_popup == true && <DeclineEditProjectPopup/>}

        {teamsReducer.open_create_team_form == true && <TeamCreationDrawer />}

        {teamsReducer.delete_team_popup == true && <DeleteTeamPopup/>}

        {teamsReducer.rename_team_popup == true && <RenameTeamPopup/>}

        {/* {teamsReducer.invite_team_members_popup == true && <InviteMembersPopup members={members} options={dropdownReducer?.organisation_roles} roleNameFromId={getRoleNamesFromIds}/>} */}

        {teamsReducer.invite_team_members_popup == true && <InviteOrganisationMembersPopup members={members} options={dropdownReducer?.organisation_roles} roleNameFromId={getRoleNamesFromIds}/>}

        {teamsReducer.remove_member_confirmation_popup == true && <RemoveOrganisationMemberConfirmationPopup/>}

        {/* {teamsReducer.assign_role_popup == true && <AssignRolePopup/>} */}

        {teamsReducer.assign_role_popup == true && <AssignAdminRolePopup/>}

        {teamsReducer.view_members_popup == true && <ViewOrganisationMembersPopup  options={dropdownReducer?.organisation_roles}/>}

        {createEventReducer?.open_backdrop_project_creation === true && <BackdropCreateProject />}

    </AuthLayout>
}
export default Dashboard;